<div class="modal-ga" *ngIf="toShowDialog" [class.visible]="isVisible">
    <span>
        Usamos cookies para melhorar a experiência no InvoiceCon. Veja mais em
        <a href="https://www.cast4it.com/politica-de-privacidade-2/">Política de Privacidade</a>
        e
        <a href="https://www.cast4it.com/codigo-de-etica-e-conduta/">Ética e Conduta</a>
    </span>
    <div>
        <button mat-button class="btn btn-extra" (click)="rejeitar()">Rejeitar</button>
        <button mat-button class="btn btn-extra" (click)="aceitar()">Aceitar</button>
    </div>
</div>
